import React from 'react'
// import {isLoggedIn} from "../services/auth"

const Layout = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}

export default Layout